module.exports = __webpack_public_path__ + "img/icon_lcsl.c0ed8739.png";